const settings = {
  graphqlEndpoint:
    "https://5bazdb6qpzejfl42x5nqtrw5he.appsync-api.us-east-1.amazonaws.com/graphql",
  region: "us-east-1",
  authenticationType: "AMAZON_COGNITO_USER_POOLS",
  apiKey: "null",
};

export default settings;
